import { StateTrackedData } from "@common/domain/common.model";

export interface AuthStore {
  status: "LOGGED_IN" | "LOGGED_OUT" | "LOADING";
  user: StateTrackedData<User | undefined>;
  token: StateTrackedData<string | undefined>;
  userInfo: StateTrackedData<any | undefined>;
}

export interface User {
  id: string;
  username: string;
  email: string;
  roles: string[];
  avatar: string;
  issuedAt?: number;
  expiresAt?: number;
  issuer?: string;
}

export function buildUserFromToken(token: any): User {
  return {
    id: token.id,
    username: token.sub,
    email: token.email,
    roles: token.roles,
    avatar: token.avatar,
    issuedAt: token.iat,
    expiresAt: token.exp,
    issuer: token.iss,
  };
}
